import axios, { AxiosError } from 'axios';
import * as Sentry from '@sentry/react';
import { IThrownException } from '@acorn-portal/shared/src/services/interface/INetworkError';

export const typeThrownException = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	toBeDetermined: any,
): toBeDetermined is IThrownException => toBeDetermined;

const API_POLICY_TOKEN = axios.create();

API_POLICY_TOKEN.interceptors.request.use(
	(request) => {
		// Any status code that lie within the range of 2xx cause this function to trigger
		// Do something with response data
		return request;
	},
	(error: AxiosError) => {
		// Any status codes that falls outside the range of 2xx cause this function to trigger
		// Do something with response error
		return Promise.reject(error);
	},
);
API_POLICY_TOKEN.interceptors.response.use(
	(response) => {
		// Any status code that lie within the range of 2xx cause this function to trigger

		return response;
	},
	(error: AxiosError) => {
		// Any status codes that falls outside the range of 2xx cause this function to trigger
		// Do something with response error

		Sentry.captureException(error);

		if (error.status === 403) {
			// Take us home.
			window.location.assign('/');
		}
		return Promise.reject(error);
	},
);

export default API_POLICY_TOKEN;
